import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SuccessAlert from "./../child/Alert/SuccessAlert";
import DengerAlert from "./../child/Alert/DengerAlert";
import OtpInput from "react-otp-input";
import "./../../custom.css";

const OTPLayer = () => {
  const [otp, setOtp] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [timer, setTimer] = useState(300);
  const [otpExpired, setOtpExpired] = useState(false);
  const [otpExpiredError, setOtpExpiredError] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) navigate("/dashboard");

    document.body.classList.add("signin-page");
    return () => document.body.classList.remove("signin-page");
  }, [navigate]);

  useEffect(() => {
    const savedOtpStart = localStorage.getItem("otpStartTime");

    if (savedOtpStart) {
      const elapsed = Math.floor((Date.now() - parseInt(savedOtpStart)) / 1000);
      const remaining = 300 - elapsed;
      setTimer(remaining > 0 ? remaining : 0);
      setOtpExpired(remaining <= 0);
    } else {
      localStorage.setItem("otpStartTime", Date.now().toString());
      setTimer(300);
    }
  }, []);

  useEffect(() => {
    if (timer <= 0 || otpExpired) return;

    const countdown = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(countdown);
          setOtpExpired(true);
          setOtpExpiredError("OTP is Expired");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(countdown);
  }, [timer, otpExpired]);

  const formatTime = (seconds) => {
    const m = String(Math.floor(seconds / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  const validateInputs = () => {
    const newErrors = {};
    if (!otp) newErrors.otp = "One Time Code is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleOtp = async (e) => {
    e.preventDefault();
    if (!validateInputs()) return;

    setLoading(true);
    const email = localStorage.getItem("email");

    if (!email) {
      setErrorMessage("Email not found. Please login again.");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/otpVerify`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp }),
      });

      const data = await response.json();

      if (!response.ok) {
       setErrors({ otp: data.message });
       setOtp("");
      } else {
       
        localStorage.setItem("adminId", data.data._id);
        setSuccessMessage("OTP verified successfully");
        localStorage.removeItem("otpStartTime");
        setTimeout(() => {
          setSuccessMessage("");
          navigate("/resetpassword");
        }, 3000);
      }
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleResendOTP = async () => {
    setResendLoading(true);
    const email = localStorage.getItem("email");

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/resendOtp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
          setOtp("");
          if(data.message == "You've reached the maximum number of OTP resend attempts for today")
          {
             setOtpExpiredError(data.message);
          }
          else
          {
            setErrors({ otp: data.message });
          }
          
        // setErrorMessage(data.message || "Failed to resend OTP");
      } else {
        setOtp("");
        const now = Date.now();
        localStorage.setItem("otpStartTime", now.toString());
        setOtpExpired(false);
         setOtpExpiredError("")
        setTimer(300);
        setSuccessMessage("OTP resent successfully.");
      }
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setResendLoading(false);
      setTimeout(() => setSuccessMessage(""), 3000);
    }
  };

  return (
    <section className="auth bg-base d-flex flex-wrap">
      {successMessage && <SuccessAlert message={successMessage} onClose={() => setSuccessMessage("")} />}
      {errorMessage && <DengerAlert message={errorMessage} onClose={() => setErrorMessage("")} />}

      <div className="auth-left d-lg-block d-none">
        <div className="d-flex align-items-center flex-column h-100 justify-content-center">
          <img src={`${process.env.REACT_APP_PUBLIC_UR}/assets/images/auth/OTP-image.png`} alt="Auth"  />
        </div>
      </div>

      <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
        <div className="max-w-464-px mx-auto w-100 text-center">
          <img src={`${process.env.REACT_APP_PUBLIC_UR}/assets/images/logo.svg`} alt="Logo"   style={{ height: '5.5rem' }}/>
          <h4 className="mb-12">OTP Verification</h4>
          <p className="mb-32 text-secondary-light text-lg">Enter your OTP to continue.</p>

          <form onSubmit={handleOtp}>
            <div className="d-flex justify-content-center mb-3">
              <OtpInput
                value={otp}
                onChange={(value) => {
                  if (/^\d*$/.test(value)) {
                    setOtp(value);
                    setErrors((prev) => ({ ...prev, otp: "" }));
                  }
                }}
                numInputs={4}
                isInputNum={true}
                shouldAutoFocus={true}
                isDisabled={otpExpired}
                renderSeparator={<span>-</span>}
                renderInput={(props) => (
                  <input
                    {...props}
                    className="otp-input"
                    inputMode="numeric"
                    pattern="\d*"
                    maxLength={1}
                    onKeyDown={(e) => {
                      const allowed = ["Backspace", "ArrowLeft", "ArrowRight", "Tab"];
                      if (!/\d/.test(e.key) && !allowed.includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />
                )}
              />
            </div>
                  
            {errors.otp && <p className="text-danger mt-1 text-center" >{errors.otp}</p>}

            {!otpExpired ? (
              <p className="text-secondary text-center">Expires in {formatTime(timer)}</p>
            ) : (
              <p className="text-danger text-center">{otpExpiredError}</p>
            )}

            <button
              type="submit"
              className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
              disabled={loading || otpExpired || otp.length < 4}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>

            {otpExpired && (
              <div className="text-center mt-3">
                <button
                  type="button"
                  className="btn btn-link p-0 text-primary"
                  onClick={handleResendOTP}
                  disabled={resendLoading}
                >
                  {resendLoading ? "Resending..." : "Resend OTP"}
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default OTPLayer;
